import React from 'react';
import { useTranslation } from 'react-i18next';

import type { AttachmentMetadataDTO } from '@/services/ws-funnel/src/main/resources/rest-api';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { Icons, Table } from '@/js/libs/ui';

type AttachmentRowProps = {
  attachment: AttachmentMetadataDTO;
  onDelete: (attachment: AttachmentMetadataDTO) => void;
  onDownload: (attachment: AttachmentMetadataDTO) => void;
};

export const AttachmentRow: React.FC<AttachmentRowProps> = React.memo(function AttachmentRow({ attachment, onDelete, onDownload }) {
  const [t] = useTranslation(['backend', 'common']);

  const handleDelete = useCallbackRef(() => {
    onDelete(attachment);
  });

  const handleDownload = useCallbackRef(() => {
    onDownload(attachment);
  });

  return (
    <Table.Tr>
      <Table.Td>{attachment.name}</Table.Td>
      <Table.Td type='action'>
        <Table.ActionsList>
          <Table.ActionsListItem onClick={handleDelete} remove icon={<Icons.Trash />}>
            <div>{t('common:DELETE')}</div>
          </Table.ActionsListItem>
          <Table.ActionsListItem onClick={handleDownload} icon={<Icons.Download />}>
            {t('common:DOWNLOAD')}
          </Table.ActionsListItem>
        </Table.ActionsList>
      </Table.Td>
    </Table.Tr>
  );
});
